import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { VendorDetailsWrapper } from './VendorDetailsWrapper/VendorDetailsWrapper'
import { setLoading } from 'redux/store/common/slice'
import './styles.scss'
import { useDispatch } from 'react-redux'
import { getVendorDetails } from './api'
import { setVendorInfoAction } from '../../../../redux/store/vendorInfo/slice'
import { VendorDetails as VendorDetailsType } from '../VendorCreation/types'
import { MyOrganization } from 'features/MyCommunity/MyOrganization/MyOrganization'

export const VendorDetails = () => {
  const [data, setData] = useState<VendorDetailsType>()
  const dispatch = useDispatch()
  const { id } = useParams()

  useEffect(() => {
    getDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getDetails = async () => {
    try {
      dispatch(setLoading(true))
      const { data } = await getVendorDetails(id as string)
      const vendorDetails: VendorDetailsType = {
        ...data,
        alternate_name_set: data.alternate_name_set
          ? data.alternate_name_set.map((item) => ({ name: item }))
          : []
      }
      dispatch(
        setVendorInfoAction({
          vendorInfo: vendorDetails
        })
      )
      setData(vendorDetails)
    } finally {
      dispatch(setLoading(false))
    }
  }

  return (
    <VendorDetailsWrapper name={data?.business_name}>
      <MyOrganization />
    </VendorDetailsWrapper>
  )
}
